// src/firebase.js
// ------------------------------------------------------------------
//  Firebase initialisation (web version)
// ------------------------------------------------------------------
//  NOTE  If you use React‑Native with @react-native-firebase/* you
//  will have a *separate* firebase.js inside the mobile project.
// ------------------------------------------------------------------

import { initializeApp }  from 'firebase/app';
import { getAuth }        from 'firebase/auth';
import { getFirestore }   from 'firebase/firestore';
import { getStorage }     from 'firebase/storage';

/* ------------------------------------------------------------------ */
/*  Environment‑driven config                                           */
/* ------------------------------------------------------------------ */
//  Double‑check your .env contains the **new** bucket name
//    REACT_APP_STORAGE_BUCKET=backpassbeta.firebasestorage.app
//  and that all the other REACT_APP_* variables exist.

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_API_KEY,          // ✅  or REACT_APP_FIREBASE_API_KEY
  authDomain:        process.env.REACT_APP_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_STORAGE_BUCKET,   // ✅  MUST be *.firebasestorage.app
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_APP_ID,
};

/* ------------------------------------------------------------------ */
/*  Sanity‑check – throw early if any variable is missing               */
/* ------------------------------------------------------------------ */
const missing = Object.entries(firebaseConfig)
  .filter(([, v]) => !v)
  .map(([k]) => k);

if (missing.length) {
  console.error(`❌ Missing Firebase env vars: ${missing.join(', ')}`);
  throw new Error('Firebase configuration incomplete – check .env');
}

/* ------------------------------------------------------------------ */
/*  Initialise Firebase services                                        */
/* ------------------------------------------------------------------ */
const app      = initializeApp(firebaseConfig);
const auth     = getAuth(app);
const db       = getFirestore(app);

//  Force the SDK to use the **explicit** bucket URL so we never fall
//  back to the deprecated *.appspot.com bucket on older browsers.
const storage  = getStorage(app, `gs://${firebaseConfig.storageBucket}`);

console.log('✅ Firebase initialised');
console.table({
  projectId : firebaseConfig.projectId,
  storage   : firebaseConfig.storageBucket,
});

export { auth, db, storage };
